import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CallingMissedIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CallingMissed",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M3.24 16.52c.14.39.31.77.5 1.17 1.21 2.48 2.75 4.59 4.59 6.4a22.9 22.9 0 0 0 6.27 4.54l.13.06c.71.35 1.55.67 2.43.92l.11.03c2.64.71 5 .43 6.44-1.01l1.35-1.35c.35-.35.56-.83.56-1.35s-.21-1.01-.56-1.35l-3.62-3.62c-.35-.35-.83-.56-1.35-.56s-1.01.21-1.35.56L16.1 23.6c-.23.23-.55.37-.91.37s-.67-.14-.91-.37l-5.45-5.41c-.23-.23-.38-.55-.38-.91s.14-.67.38-.91l2.64-2.64c.35-.35.56-.83.56-1.35s-.21-1.01-.56-1.35l-3.6-3.64c-.35-.35-.83-.56-1.35-.56s-1.01.21-1.35.56L3.81 8.74c-1.69 1.7-1.78 4.62-.57 7.82Zm14.02-2.21c.19.19.45.31.74.31s.55-.12.74-.31l4.51-4.51 4.51 4.51c.19.19.45.31.74.31.58 0 1.05-.47 1.05-1.05 0-.29-.12-.55-.31-.74l-4.51-4.51 4.51-4.51c.19-.19.31-.45.31-.74s-.12-.55-.31-.74-.45-.31-.74-.31-.55.12-.74.31l-4.51 4.51-4.51-4.51c-.19-.19-.45-.31-.74-.31s-.55.12-.74.31-.31.45-.31.74.12.55.31.74l4.51 4.51-4.51 4.51c-.19.19-.31.45-.31.74s.12.55.31.74"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M21.13 29.29c-2.18 0-4.23-.85-5.77-2.39L4.25 15.78A8.12 8.12 0 0 1 2.8 6.22a1.14 1.14 0 1 1 2.02 1.06 5.84 5.84 0 0 0 1.05 6.88l11.12 11.12C18.1 26.39 19.57 27 21.14 27s3.04-.61 4.15-1.72l1.25-1.25-4.26-4.26a3.47 3.47 0 0 1-4.8-.12l-6.01-6.01a3.45 3.45 0 0 1-1.02-2.46c0-.87.32-1.69.9-2.33L6.3 3.81c-.45-.45-.45-1.17 0-1.62s1.17-.45 1.62 0l5.84 5.85c.45.45.45 1.17 0 1.62l-.68.68c-.23.23-.35.53-.35.84s.12.62.35.84l6.01 6.01c.45.45 1.18.47 1.65.04l.79-.73c.45-.41 1.15-.4 1.58.04l5.84 5.84a1.16 1.16 0 0 1 0 1.62l-2.05 2.05a8.1 8.1 0 0 1-5.77 2.39ZM21.29 11c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l6.86-6.86c.45-.45 1.17-.45 1.62 0s.45 1.17 0 1.62l-6.86 6.86c-.22.22-.52.33-.81.33"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.14 11c-.29 0-.58-.11-.81-.33l-6.86-6.86c-.45-.45-.45-1.17 0-1.62s1.17-.45 1.62 0l6.86 6.86a1.14 1.14 0 0 1-.81 1.95"
      })]
    })
  }));
};
CallingMissedIcon.displayName = 'CallingMissedIcon';